export default "__VITE_ASSET__31c176ff__"